export const CATEGORIES = [
  { key: "ocean-core", name: "Ocean Core", sub: "Our foundation range from the sea." },
  { key: "value-packs", name: "Value Packs", sub: "Two bottles of a favourite in one order." },
  { key: "everyday-health", name: "Everyday Health", sub: "Single products for your everyday routine." },
  { key: "hydration", name: "Hydration", sub: "Drink mixes to stir into water." },
  { key: "ocean-stacks", name: "Ocean Stacks", sub: "Bundles of our products in one order." },
  { key: "vip-packs", name: "VIP Packs", sub: "Members-only packs for customers with an active subscription." },
];

export const FEATURED_ID = "fish-oil";
